import React from 'react';

const skillCategories = [
    {
        title: "Languages",
        skills: [
            { title: "Java",    level: "daily" },
            { title: "SQL",     level: "daily" },
            { title: "Python",  level: "daily" },
            { title: "GoLang",  level: "completed" },
            { title: "C",       level: "completed" },
        ],
    },
    {
        title: "Frontend",
        skills: [
            { title: "React",       level: "daily" },
            { title: "Javascript",  level: "daily" },
            { title: "Typescript",  level: "daily" },
            { title: "Angular",     level: "completed" },
        ],
    },
    {
        title: "Soft Skills",
        skills: [
            { title: "Scrum / Agile",       level: "neutral" },
            { title: "People Management",   level: "neutral" },
            { title: "Financial Forecast",  level: "neutral" },
            { title: "Sales",               level: "neutral" },
            { title: "Presenting",          level: "neutral" },
        ],
    },
    {
        title: "DevOps & Tools",
        skills: [
            { title: "AWS",     level: "daily" },
            { title: "Bash",    level: "daily" },
            { title: "CI/CD",   level: "daily" },
            { title: "Git",     level: "daily" },
            { title: "Docker",  level: "completed" },
        ],
    },
];

export default function SkillsSection() {
    return (
        <div className="skills-grid">
            {skillCategories.map(category => (
                <div key={category.title} className="skill-card">
                    <div className="skill-card-hd">{category.title}</div>
                    <div className="skill-chips">
                        {category.skills.map(skill => (
                            <span
                                key={skill.title}
                                className={'skill-chip ' + skill.level}
                            >
                                {skill.title}
                            </span>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
